import { Button, Col, Form, Modal, Row, Spin, message } from 'antd';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import MonacoEditor from 'react-monaco-editor';
import { thingModelExport, thingModelImport } from '@/api/thingmodel';
import copy from 'copy-to-clipboard';

export type DataModalRef = {
  open: (product_id: string, type: 'import' | 'export') => void;
};

export type DataModalProps = {
  onSuccess: () => void;
};

function downloadJson(fileName: string, json: string | Object) {
  const jsonStr = json instanceof Object ? JSON.stringify(json) : json;

  const url = window.URL || window.webkitURL || window;
  const blob = new Blob([jsonStr]);
  const saveLink = document.createElement('a');
  saveLink.href = url.createObjectURL(blob);
  saveLink.download = fileName;
  saveLink.click();
}

const DataModal = forwardRef<DataModalRef, DataModalProps>((props, ref) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState<boolean>(false);
  const [type, setType] = useState<'import' | 'export'>('import');

  const [loading, setLoading] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const exportData = async (product_id: string) => {
    setLoading(true);
    try {
      const { result } = await thingModelExport<{ data: string }>({ product_id });
      let data = result.data;
      try {
        data = JSON.stringify(JSON.parse(data), null, 2);
      } catch {}
      form.setFieldsValue({ data, product_id });
    } catch {
    } finally {
      setLoading(false);
    }
  };

  const importData = async () => {
    setSubmitting(true);
    try {
      const values = await form.validateFields();
      await thingModelImport(values);
      message.success('导入成功');
      props.onSuccess?.();
      setOpen(false);
    } catch {
    } finally {
      setSubmitting(false);
    }
  };

  useImperativeHandle(ref, () => {
    return {
      open(product_id, type) {
        if (type === 'export') exportData(product_id);
        else {
          // form.resetFields();
          form.setFieldsValue({ data: '', product_id });
        }
        setType(type);
        setOpen(true);
      },
    };
  });
  return (
    <Modal
      open={open}
      onCancel={() => {
        setOpen(false);
      }}
      destroyOnClose={false}
      onOk={() => {
        if (type === 'import') importData();
        else setOpen(false);
      }}
      okText="确定"
      cancelText="取消"
      title={type !== 'export' ? '导入' : '导出'}
      confirmLoading={submitting}
      centered
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Form.Item name="product_id" noStyle>
            <div></div>
          </Form.Item>
          {type === 'export' && (
            <Row justify={'space-between'}>
              <Col>
                <Button
                  type="link"
                  style={{ paddingLeft: 0, paddingRight: 0 }}
                  onClick={() => {
                    downloadJson('Download.json', form.getFieldValue('data'));
                  }}
                >
                  Download.json
                </Button>
              </Col>
              <Col>
                <Button
                  style={{ paddingLeft: 0, paddingRight: 0 }}
                  type="link"
                  onClick={() => {
                    const data = form.getFieldValue('data');
                    copy(data);
                    message.success('复制成功');
                  }}
                >
                  复制JSON到剪贴板
                </Button>
              </Col>
            </Row>
          )}
          <Form.Item
            name="data"
            label="物模型JSON"
            rules={
              type === 'export'
                ? []
                : [
                    { required: true, message: '请输入json' },
                    {
                      validator: async (_rule, value) => {
                        try {
                          value && JSON.parse(value);
                        } catch {
                          throw new Error('请输入正确的 json 格式');
                        }
                      },
                    },
                  ]
            }
          >
            <MonacoEditor
              height="500"
              language="json"
              theme="vs-dark"
              options={{
                readOnly: type === 'export',
              }}
              editorWillMount={(monaco) => {
                // monaco.editor.onDidChangeMarkers(([uri]) => {
                //   const markers = monaco.editor.getModelMarkers({ resource: uri });
                //   console.log({ markers });
                //   if (markers.length) {
                //     form.setFields([{ name: 'data', errors: ['请输入正确的 json 格式'], validating: true }]);
                //   }
                // });
                monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
                  validate: true,
                  allowComments: true,
                });
              }}
            ></MonacoEditor>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
});

export default DataModal;
